import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { userActions } from "../../redux/actions"; // adjust path
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getUserData } from "../../system";
import { typeConstants } from "../../constants";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isSpinnerActive = useSelector(
    (state) => state.spinnerReducer.spinnerActive
  );

  // Local form state
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  // Handle input change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  // Handle submit
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      userActions.login(formData, () => {
        // Navigate to dashboard on success
        const decryptedData = getUserData();
        if (decryptedData.userTypeId == typeConstants.RECRUITER) {
          navigate("/assigned-projects");
        } else {
          navigate("/");
        }
      })
    );
  };

  return (
    <div className="auth-page-wrapper">
      {/* Spinner Overlay */}
      {isSpinnerActive && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
            flexDirection: "column",
            color: "#fff",
            fontFamily: "sans-serif",
          }}
        >
          <div className="spinner-glow">
            <Spinner
              animation="border"
              variant="light"
              role="status"
              style={{ width: "4rem", height: "4rem" }}
            >
              {/* <span className="visually-hidden">Loading...</span> */}
            </Spinner>
          </div>
          {/* <p style={{ marginTop: "15px", fontSize: "1.2rem" }}>Loading...</p> */}
        </div>
      )}
      {/* Background */}
      {/* <div className="auth-one-bg-position auth-one-bg" id="auth-particles">
        <div className="bg-overlay"></div>
        <div className="shape">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 1440 120"
          >
            <path d="M 0,36 C 144,53.6 432,123.2 720,124 C 1008,124.8 1296,56.8 1440,40L1440 140L0 140z"></path>
          </svg>
        </div>
      </div> */}

      {/* Content */}
      <div className="auth-page-content">
        <div className="container">
          {/* Header */}
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <a href="/" className="d-inline-block auth-logo">
                    <img src="assets/images/logo-light.png" className="w-25" alt="" />
                  </a>
                </div>
                {/* <p className="mt-3 fs-15 fw-medium">
                  Premium Admin & Dashboard Template
                </p> */}
              </div>
            </div>
          </div>

          {/* Login form */}
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6 col-xl-5">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Welcome Back !</h5>
                    <p className="text-muted">Sign in to continue.</p>
                  </div>
                  <div className="p-2 mt-4">
                    <form className="h-auto" onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <label htmlFor="username" className="form-label">
                          Username
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="username"
                          placeholder="Enter username"
                          value={formData.username}
                          onChange={handleChange}
                        />
                      </div>

                      <div className="mb-3">
                        {/* <div className="float-end">
                          <a
                            href="auth-pass-reset-basic.html"
                            className="text-muted"
                          >
                            Forgot password?
                          </a>
                        </div> */}
                        <label className="form-label" htmlFor="password-input">
                          Password
                        </label>
                        <div className="position-relative auth-pass-inputgroup mb-3">
                          <input
                            type="password"
                            className="form-control pe-5 password-input"
                            placeholder="Enter password"
                            id="password"
                            value={formData.password}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="auth-remember-check"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="auth-remember-check"
                        >
                          Remember me
                        </label>
                      </div> */}

                      <div className="mt-4">
                        <button className="btn btn-success w-100" type="submit">
                          Sign In
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>

              {/* <div className="mt-4 text-center">
                <p className="mb-0">
                  Don't have an account ?{" "}
                  <a
                    href="auth-signup-basic.html"
                    className="fw-semibold text-primary text-decoration-underline"
                  >
                    Signup
                  </a>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      {/* <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center">
                <p className="mb-0 text-muted">
                  &copy; Developed <i className="mdi mdi-heart text-danger"></i>{" "}
                  By GenxBusinesses
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer> */}
    </div>
  );
};

export default Login;
